import React from 'react';
import { Route } from 'react-router-dom';
import BlogPostsList from '../pages/blog/BlogPostsList';
import CreateBlogPost from '../pages/blog/CreateBlogPost';
import EditBlogPost from '../pages/blog/EditBlogPost';
import ProtectedRoute from '../components/global/ProtectedRoute';

const blogPostsRoutes = (
    <>
        <Route
            path="/blog"
            element={
                <ProtectedRoute requiredPermission="blogs.view">
                    <BlogPostsList />
                </ProtectedRoute>
            }
        />
        <Route
            path="/blog/create"
            element={
                <ProtectedRoute requiredPermission="blogs.create">
                    <CreateBlogPost />
                </ProtectedRoute>
            }
        />
        <Route
            path="/blog/:id/edit"
            element={
                <ProtectedRoute requiredPermission="blogs.update">
                    <EditBlogPost />
                </ProtectedRoute>
            }
        />
    </>
);

export default blogPostsRoutes;
